import { DataPoint, Record } from '@mtna/data-core-ui';
import { VariableGroup } from '@mtna/pojo-consumer-ui';

import { RdsVariableUtil } from './variable-util';

// @dynamic
export class RdsRecordUtil {
  static generateUniqueId(record: Record, primaryKey: VariableGroup) {
    if (!record || !primaryKey) {
      return '';
    }
    // Get they key of DataPoints
    // then join the values to form an ID
    return RdsRecordUtil.getKey(record, primaryKey)
      .map((dp) => dp.value.value)
      .join();
  }

  static getKey(record: Record, primaryKey: VariableGroup): Array<DataPoint> {
    if (!record || !primaryKey) {
      return [];
    }
    // For each variable key, find the DataPoint in the record
    return primaryKey.variables.map((keyVar) => {
      return record.data.find((d) => RdsVariableUtil.compareVariables(d.value.variable, keyVar));
    });
  }
}
